import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

const ReportCsrSalesSummaryData = (props: RouteComponentProps<{}>) => {
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [loading, setLoading] = React.useState(true);
    const [startDate, setStartDate] = React.useState("");
    const [endDate, setEndDate] = React.useState("");

    React.useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunSalesByProductReport&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                setLoading(false);
            } else if (res.data == false) {
                //redirect to 403 permission denied
                props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const handleStartDateChange = (e: any) => {
        let error = errors;
        delete error["startDate"];
        setErrors(error);

        setStartDate(e.target.value);
    }

    const handleEndDateChange = (e: any) => {
        let error = errors;
        delete error["endDate"];
        setErrors(error);

        setEndDate(e.target.value);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (!startDate) {
            formIsValid = false;
            errorList["startDate"] = "Start Date is required";
        }

        if (!endDate) {
            formIsValid = false;
            errorList["endDate"] = "End Date is required";
        }

        if (startDate && endDate && endDate < startDate) {
            formIsValid = false;
            errorList["startDate"] = "Start Date must be < End Date";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const runReport = (e: any) => {
        e.preventDefault();

        if (validate()) {
            var url = "/report/CsrSalesSummary/" + startDate + "/" + endDate + "/-1/-1/-1";
            window.open(url, '_blank');
        }
    }

    const renderDetails = (
        <div>
            <div>
                <h1>CSR Sales Summary Report</h1>
            </div>
            <div className="marginTop20">
                <div>Report showing a summary of jobs entered between Start Date and End Date.</div>
                <span>Select a Start Date and End Date to run the report. </span>
            </div>
            <div>
                <label className="input-group" htmlFor="startDate">
                    <span className="label">Start Date</span>
                    <input type='date' id="startDate" name="startDate" className='input' value={startDate} onChange={(e) => handleStartDateChange(e)}></input>
                </label>
                <span className={errors["startDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["startDate"]}</span>

                <label className="input-group" htmlFor="endDate">
                    <span className="label">End Date</span>
                    <input type='date' id="endDate" name="endDate" className='input' value={endDate} onChange={(e) => handleEndDateChange(e)}></input>
                </label>
                <span className={errors["endDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["endDate"]}</span>
            </div>
            <button className="defaultbutton marginLeftLabel marginRight10" type='button' onClick={runReport}>Run Report</button>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

};

export default ReportCsrSalesSummaryData;